import { COMPARING_ITEMS_AMOUNT } from '@/store';
import { ComparingItems } from '@/types/vuex/state';

export const omitEmptyItem = (items: number[], comparingItems: ComparingItems): ComparingItems => {
    if (items.length < COMPARING_ITEMS_AMOUNT && comparingItems.length >= COMPARING_ITEMS_AMOUNT) {
        const indexOfLastEmptyItem = comparingItems.lastIndexOf(0);
        if (indexOfLastEmptyItem !== -1) {
            const cutComparingItems = [...comparingItems];
            cutComparingItems.splice(indexOfLastEmptyItem, 1);
            return cutComparingItems as ComparingItems;
        }
    }
    throw new Error();
};
